import React from 'react';
import { motion } from 'motion/react';
import { Video, Zap, Music, ArrowRight } from 'lucide-react';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';

const TikTok = () => {
  return (
    <div className="pt-24 pb-24 bg-[#030303] min-h-screen">
      <SEO 
        title="AI TikTok Caption and Content Idea Generator - Go Viral"
        description="Generate TikTok hooks, captions, and content ideas with PlataPost's AI TikTok generator. Perfect for creators and brands looking for more views."
      />

      <div className="max-w-7xl mx-auto px-6">
        <div className="flex flex-col lg:flex-row items-center gap-20 mb-40">
          <div className="flex-1 space-y-8">
            <div className="inline-flex items-center gap-3 px-4 py-1.5 rounded-full glass-card border border-white/5 text-cyan-400 text-[10px] font-black uppercase tracking-widest leading-none">
              <Zap className="w-3.5 h-3.5" />
              <span>Trend Optimized</span>
            </div>
            <h1 className="text-5xl lg:text-7xl font-black text-white leading-tight tracking-tighter">AI TikTok <br /> <span className="text-white">Content Engine.</span></h1>
            <p className="text-xl text-gray-400 mb-8 leading-relaxed font-medium">
              Don't just post. Trend. PlataPost generates viral hooks, engaging captions, and video scripts designed for the TikTok algorithm.
            </p>
            <Link to="/dashboard" className="inline-flex px-10 py-5 bg-indigo-600 text-white rounded-2xl font-black uppercase tracking-widest text-xs hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Generate TikTok Ideas
            </Link>
          </div>
          <div className="flex-1 w-full glass-card rounded-[4rem] p-12 flex items-center justify-center border border-white/5 relative overflow-hidden group shadow-2xl shadow-cyan-500/5">
             <div className="absolute inset-0 bg-cyan-500/5 blur-[100px] pointer-events-none" />
             <div className="w-64 h-[450px] bg-black rounded-[2.5rem] shadow-2xl border border-white/10 overflow-hidden relative z-10 group-hover:scale-105 transition-transform duration-700">
                <div className="absolute inset-x-0 top-0 h-16 bg-gradient-to-b from-black/60 to-transparent z-20" />
                <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent z-10" />
                <div className="absolute bottom-10 left-6 right-6 space-y-3 z-20">
                   <div className="h-2 w-3/4 bg-white/30 rounded-full animate-pulse" />
                   <div className="h-2 w-full bg-white/20 rounded-full" />
                   <div className="h-2 w-1/2 bg-cyan-400/40 rounded-full shadow-[0_0_8px_rgba(34,211,238,0.4)]" />
                </div>
             </div>
          </div>
        </div>

        <section className="mb-40">
          <div className="text-center mb-24 space-y-4">
            <h2 className="text-4xl lg:text-5xl font-black text-white tracking-tighter leading-tight">Engineered for For You Page</h2>
            <p className="text-gray-400 font-medium max-w-xl mx-auto">Short-form video success starts with the perfect hook.</p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
             {[
               { icon: Zap, title: "Viral Hooks", desc: "Get three power-hooks for every video concept to maximize retention." },
               { icon: Music, title: "Trend Alignment", desc: "Ideas that align with current audio and visual trends in your niche." },
               { icon: Video, title: "Script Guidance", desc: "Full scripts and shot lists for your short-form video content." }
             ].map((feature, i) => (
                <div key={i} className="p-12 glass-card rounded-[3rem] border border-white/5 hover:bg-white/5 transition-all group text-center">
                   <div className="w-20 h-20 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center mx-auto mb-10 text-cyan-400 group-hover:scale-110 group-hover:rotate-6 transition-all shadow-xl shadow-cyan-500/5">
                      <feature.icon className="w-10 h-10" />
                   </div>
                   <h3 className="text-3xl font-black text-white mb-6 tracking-tight">{feature.title}</h3>
                   <p className="text-gray-400 leading-relaxed font-medium">{feature.desc}</p>
                </div>
             ))}
          </div>
        </section>

        <div className="text-center glass-card rounded-[4rem] p-24 border border-white/5 relative overflow-hidden shadow-2xl shadow-cyan-500/10">
           <div className="absolute inset-0 bg-cyan-500/10 blur-[150px] pointer-events-none" />
           <h2 className="text-4xl lg:text-6xl font-black text-white mb-10 tracking-tighter">Scale your short-form <span className="text-cyan-400">reach.</span></h2>
           <Link to="/dashboard" className="relative z-10 inline-flex px-12 py-6 bg-indigo-600 text-white rounded-2xl font-black text-sm uppercase tracking-[0.2em] hover:bg-indigo-700 transition-all shadow-2xl shadow-indigo-600/30">
              Start Creating Now
           </Link>
        </div>
      </div>
    </div>
  );
};

export default TikTok;
